<mat-card>
  <mat-card-header>
    <mat-card-title> {{ 'FRONTEND.BUSINESSES.MEDIA_TAB.IMAGE_MENU.CROP_PHOTO' | translate }} </mat-card-title>
  </mat-card-header>
  <glxy-image-editor
    [maxEditorHeight]="'100px'"
    [fileInfo]="data.croppingFile"
    [align]="'end'"
    [aspectRatios]="[{ label: 'N/A', value: aspectRatioLabel }]"
    [autoCropArea]="1"
    [maxDimensions]="data.maxDimensions"
    [minDimensions]="data.minDimensions"
    [maxEditorHeight]="maxEditorHeight"
    (closed)="closeDialog($event)"
    class="editor-with-margin"
  ></glxy-image-editor>
</mat-card>
